import { MediaParticipant } from "@dvrt/web-phone-client";
import { useRoomSettings } from "../../context";
import { gridPadding, participantPinnedTileWidth, HiddenNotPinnedParticipants } from "./styles";
import ParticipantTile from "./tile/ParticipantTile";
import EvenGrid from "./EvenGrid";
import { useWindowSize } from "conference/hooks";
import { sidebarWidth } from "../../tools";
import { Avatar, Box } from "@mui/material";
import { isPinned } from "../../types";

const hiddenPartsCntWidth = 40;

const PinnedGrid = ({ participants }: { participants: MediaParticipant[] }) => {
    const { pinnedParticipants } = useRoomSettings();

    const pinnedMediaParticipants = participants.filter((p) => isPinned(pinnedParticipants, p.cname, p.screen));

    const { width } = useWindowSize();

    if (pinnedMediaParticipants.length === 0) return <EvenGrid participants={participants} />;

    const maxTileCnt = Math.floor(
        (width - sidebarWidth - gridPadding * 2 - hiddenPartsCntWidth) / (participantPinnedTileWidth + gridPadding),
    );

    const allNotPinnedParts = participants.filter((p) => !isPinned(pinnedParticipants, p.cname, p.screen));
    const notPinnedParts = allNotPinnedParts.slice(0, maxTileCnt);
    const hiddenPartsCnt = allNotPinnedParts.length - notPinnedParts.length;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", padding: 0 }}>
            <EvenGrid participants={pinnedMediaParticipants} />
            <Box
                sx={{
                    marginTop: gridPadding,
                    display: "flex",
                    width: "100%",
                    padding: 0,
                }}
            >
                {notPinnedParts.map((p) => (
                    <ParticipantTile
                        participant={p}
                        key={`${p.cname}-${p.screen}`}
                        sx={{
                            marginRight: gridPadding,
                            width: `${participantPinnedTileWidth}px !important`,
                            height: "130px !important",
                        }}
                    />
                ))}
                {hiddenPartsCnt > 0 && (
                    <HiddenNotPinnedParticipants>
                        <Avatar style={{ width: hiddenPartsCntWidth }}>+{hiddenPartsCnt}</Avatar>
                    </HiddenNotPinnedParticipants>
                )}
            </Box>
        </Box>
    );
};

export default PinnedGrid;
